
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conta",
      function () {
        return require("private-next-pages/conta/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conta"])
      });
    }
  